import React, { Component } from 'react';
import TextField from "@material-ui/core/Textfield";
import Button from "components/CustomButtons/Button.js";
import authService from '../../../../components/api-authorization/AuthorizeService'
import { BiLogInCircle } from "react-icons/bi";
import { connect } from 'react-redux';
import { setUser, loadingPage, updateErrorLoggingIn, saveLoggedUsername } from '../../../store/actions';
import history from '../../../../../src/history';
import { withStyles } from '@material-ui/core/styles';
import { isEmpty } from "lodash";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    container,
    description,
    cardTitle,
    blackColor,
    whiteColor,
    grayColor,
    hexToRgb,
    title
} from "../../../../assets/jss/material-kit-pro-react.js";
import { withRouter } from "react-router-dom";
import $ from 'jquery';
import { compose } from "redux";

const useStyles = theme => ({
    title: {
        ...title,
        "&, & + h4": {
            marginTop: "5px",
            marginBottom: "10px"
        },
    },
    description,
    cardTitle: {
        ...cardTitle,
        color: whiteColor + "  !important",
    },
    container: {
        ...container,
        zIndex: "4",
        [theme.breakpoints.down("sm")]: {
            paddingBottom: "100px",
        },
    },

    pageHeader: {
        color: whiteColor,
        border: "0",
        height: "100%",
        margin: "0",
        display: "flex!important",
        padding: "120px 0",
        position: "relative",
        minHeight: "100vh",
        alignItems: "center",
        "&:before": {
            background: "rgba(" + hexToRgb(blackColor) + ", 0.5)",
        },
        "&:before,&:after": {
            position: "absolute",
            zIndex: "1",
            width: "100%",
            height: "100%",
            display: "block",
            left: "0",
            top: "0",
            content: '""',
        },
    },
    form: {
        margin: "0",
    },
    cardHeader: {
        width: "auto",
        textAlign: "center",
    },
    socialLine: {
        marginTop: "1rem",
        textAlign: "center",
        padding: "0",
    },
    inputIconsColor: {
        color: grayColor[13],
    },
    textCenter: {
        textAlign: "center",
    },
    iconButtons: {
        marginRight: "3px !important",
        marginLeft: "3px !important",
    },
    block: {
        color: "inherit",
        padding: "0.9375rem",
        fontWeight: "500",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block",
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto",
    },
    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0",
    },
    left: {
        float: "left!important",
        display: "block",
        "&,& *,& *:hover,& *:focus": {
            color: whiteColor + "  !important",
        },
    },
    right: {
        padding: "15px 0",
        margin: "0",
        float: "right",
        "&,& *,& *:hover,& *:focus": {
            color: whiteColor + "  !important",
        },
    },
    icon: {
        width: "18px",
        height: "18px",
        top: "3px",
        position: "relative",
    },
    footer: {
        position: "absolute",
        width: "100%",
        background: "transparent",
        bottom: "0",
        color: whiteColor,
        zIndex: "2",
    },

});



const errorMess = (msg) => toast.error(msg, {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored'
});


const successMessage = (msg) => toast.success(msg , {
    position: "bottom-right",
    autoClose: 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored'
});




class LogInClass extends Component {

    state = {
        username: '',
        password: '',
        error: false,
        errorMessage: 'Login Unsuccessful',
        openModal: false,
        resetPwdEmailAddress: ''
    }

    componentDidMount() {
        //if (window.location.href === "https://apps.fpmccann.co.uk/TradeCustomerPortal/Login") {

        //    window.location.href = "https://orders.fpmccann.co.uk/TradeCustomerPortal/Login";
        //}

    }

    UsernameValueChange = e => {

        //this.setState({ username: e.target.value }, () => {
        //    //console.log(this.state.username);
        //});

        this.props.saveLoggedUsername(e.target.value);
    }

    PasswordValueChange = e => {

        this.setState({ password: e.target.value }, () => {
            //console.log(this.state.password);
        });


    }

    handleClick = () => {
        this.TryLogin()
    }


    handleClickReset = () => {

        let isValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!isValid.test(this.state.resetPwdEmailAddress) || (isEmpty(this.state.resetPwdEmailAddress))) {
            this.handleCloseClick();
            errorMess("This email address is invalid, please re-enter a valid emaill adress in order to reset password");
            return;
        }
        else {
            this.ResetPasswordEmail()
        }


    }

    handleOpenClick = () => {
        this.setState({ openModal: true }, () => {
        });

    }

    handleCloseClick = () => {
        this.setState({ openModal: false, resetPwdEmailAddress: '' }, () => {
        });

    }

    handleEmailResetChange = (e) => {
        this.setState({ resetPwdEmailAddress: e.target.value }, () => {
        });
    }




    ResetPasswordEmail = async () => {
        try {

            const response = await fetch('api/auth/resetPasswordEmail/' + this.state.resetPwdEmailAddress, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(res => res.json())
                .catch();

            if (response) {
                successMessage('A link has been sent to the following email address ' + this.state.resetPwdEmailAddress + '. Please check your inbox or junk mail to reset password')
                this.handleCloseClick();
            }
            else {
                errorMess('Error has occurred when attemping to reset password with the email ' + this.state.resetPwdEmailAddress + '. Please try again!');
                this.handleCloseClick();
            }

        }
        catch (e) {

        }
    }




    TryLogin = async () => {
        try {

            await this.props.loadingPage(true);

            const response = await fetch('api/auth/login/', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    Username: this.props.username,
                    Password: this.state.password,
                    RememberMe: false
                })
            })
                .then(res => res.json())
                .catch();

            //console.log("user ", response);

            if (response.loginId !== null) {

                const returnUrl = '/';
                const state = { returnUrl };

                const result = await authService.signIn(state);

                await this.props.updateErrorLoggingIn(false, "");

                if (response.usertype === 'customer') {
                    this.props.setUser(response);
                    await this.props.loadingPage(false);
                    /* history.push('/');*/
                    this.props.history.push('/');

                }
                else {
                    //admin
                    await this.props.loadingPage(false);
                    /*      history.push('/about-us');*/
                    /*  this.props.history.push('/about-us');*/
                }

            }
            else {
                await this.props.loadingPage(false);


                if (!isEmpty(response.errorMessage)) {
                    await this.props.updateErrorLoggingIn(true, response.errorMessage);
                }
                else {
                    await this.props.updateErrorLoggingIn(true, "Login Unsuccessful");
                }


            }
        }
        catch (e) {
            alert("error");
            console.log("error on log in", e);
        }

    }


    render() {
        const { classes } = this.props;




        return (<div>

            <div>
                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />

            </div>


            <TextField
                id="outlined-full-width"
                label="Username"
                placeholder="Username...."
                fullWidth
                margin="normal"
                variant="outlined"
                onChange={this.UsernameValueChange}
                InputLabelProps={{
                    shrink: true
                }}
                value={this.props.username}
            />
            <br />
            <br />
            <TextField
                id="outlined-password-input"
                label="Password"
                type="password"
                autoComplete="current-password"
                placeholder="Password...."
                fullWidth
                margin="normal"
                variant="outlined"
                onChange={this.PasswordValueChange}
                InputLabelProps={{
                    shrink: true
                }}

            />
            <br />

            {this.props.errorLoggingIn ? <h5 style={{ color: "red", fontWeight: "bold" }}>{this.props.loginErrorMessage}</h5> : null}
            <br />
            <Button
                style={{
                    borderRadius: 12,
                    padding: "12px 16px",
                    fontSize: "20px"
                }}
                color="info"
                size="lg"
                target="_blank"
                onClick={this.handleClick}
                type="submit"
            >
                <i className="far fa-arrow-alt-circle-right fa-2x"></i>
                &nbsp; Log In

            </Button>

            <br />

            <div >
                <p>
                    <a 
                        onClick={this.handleOpenClick}
                        style={{
                            cursor: 'pointer',
                            color: 'blue',
                            margin: "0",
                            float: "right!important",
                            display: "block"
                        }} >Forgot Password? </a>
                </p>


                <Dialog open={this.state.openModal} onClose={this.handleCloseClick}>
                    <DialogTitle>Forgotten Password</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Enter your e-mail address and click on the submit button. We will send you an e-mail with a link that you can use to reset your password.
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Email Address"
                            type="email"
                            fullWidth
                            variant="standard"
                            value={this.state.resetPwdEmailAddress}
                            onChange={this.handleEmailResetChange}
                            error={this.state.resetPwdEmailAddress !== "" && !this.state.resetPwdEmailAddress.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)}
                            helperText={this.state.resetPwdEmailAddress !== "" && !this.state.resetPwdEmailAddress.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ? 'Invalid Email Address.' : ' '}
                        />
                    </DialogContent>
                    <DialogActions>

                        <Button
                            style={{
                                borderRadius: 2,
                                padding: "9px 23px",
                                fontSize: "15px"
                            }}
                            color="danger"
                            size="lg"
                            target="_blank"
                            onClick={this.handleCloseClick}
                        >

                            Cancel
                        </Button>
                        <Button
                            style={{

                                borderRadius: 2,
                                padding: "9px 23px",
                                fontSize: "15px"
                            }}

                            color="success"
                            size="lg"
                            target="_blank"
                            onClick={this.handleClickReset}
                        >

                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>)
    };
}


const mapStateToProps = state => {
    return {
        user: state.userReducer.user,
        errorLoggingIn: state.userReducer.errorLoggingIn,
        username: state.userReducer.savedUserName,
        loginErrorMessage: state.userReducer.loginErrorMessage
    };
};

export default compose(withRouter,connect(mapStateToProps, { setUser, loadingPage, updateErrorLoggingIn, saveLoggedUsername }))(withStyles(useStyles)(LogInClass));

